import { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopProductAdd from '../../../components/Shops/Products/AddProduct'

const ShopProductAddPage = (): ReactElement => {
  return (
    <Layout >
      <ShopProductAdd />
    </Layout>
  )
}

export default ShopProductAddPage
